import { render, staticRenderFns } from "./colControl.vue?vue&type=template&id=7a748ae8&scoped=true&"
import script from "./colControl.vue?vue&type=script&lang=js&"
export * from "./colControl.vue?vue&type=script&lang=js&"
import style0 from "./colControl.vue?vue&type=style&index=0&id=7a748ae8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a748ae8",
  null
  
)

export default component.exports